import { mainMenu, dropdownMenu } from "./menu";
import headerInit from "./header";
import { modalDialog } from "./modals";
import { ready } from "./utils";
import { autoAccidentSliders } from "./sliders";
import { modalDialog } from "./modals";
import { targetFaqItems } from "./faq";
import { lighboxImages } from "./lighbox";
import { cf7MaskTelValidation } from "./cf7-phone-mask";


console.log('scripts included')
ready(() => {
  mainMenu();
  dropdownMenu();
  headerInit();
  modalDialog();
  autoAccidentSliders();
  modalDialog();
  targetFaqItems();
  lighboxImages();
  cf7MaskTelValidation();
});


